import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

/**
 * Outlined card with an overline title, optional description, optional
 * action slot and a body that renders its children as a stack of rows
 * separated by dividers — the standard section in our detail pages.
 *
 * Mirrors the form-side `FormCard` shape so detail and edit views share
 * the same visual rhythm. Use `<DetailRow>` for label-value pairs inside.
 */
const DetailSection = ({ title, description, action, children, ...other }) => (
  <Card variant="outlined" {...other}>
    <CardContent>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={1}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ fontWeight: 600, letterSpacing: 0.8, display: 'block' }}
          >
            {title}
          </Typography>
          {description && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
              {description}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Stack>
      <Divider sx={{ my: 1.5 }} />
      <Stack divider={<Divider flexItem />}>{children}</Stack>
    </CardContent>
  </Card>
);

export default DetailSection;
